import "angular-animate";
import "angular-messages";
import "angular-material";

import materialConfig from "./material";

const materialModule = angular
  .module("app.materialModule", ["ngMaterial", "ngMessages"])
  .config(materialConfig);

export default materialModule;



// WEBPACK FOOTER //
// ./src/material/index.js